require('./brokerCustomWalletConfirmDelete.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @utils
const { FormattedText } = require('core/i18n').i18n;

// @component
const OKModal = require('components/commons/OKModal/OKModal');

const { BROKER_CUSTOM_WALLET_GENERAL_VIEW } = require('../../constants/index');

class BrokerCustomWalletConfirmDelete extends React.Component {
    constructor(props) {
        super(props);

        this.handleConfirmedDelete = this.handleConfirmedDelete.bind(this);
        this.handleCancelDelete = this.handleCancelDelete.bind(this);
    }

    buildModalDeleteConfirmation() {
        const { wallet, walletName } = this.props;

        if (wallet) {
            const modalContent = (
                <React.Fragment>
                    <div className="broker-custom-wallet-confirm-delete__modal-text">
                        <FormattedText value="brokerCustomWallet-confirmDeleteWalletText"
                            injectedStrings={[walletName]}
                        />
                    </div>
                    <div className="broker-custom-wallet-confirm-delete__modal-info">
                        <FormattedText value="brokerCustomWallet-confirmDeleteWalletInfo" />
                    </div>
                </React.Fragment>
            );

            return (
                <OKModal
                    content={modalContent}
                    footerType="navigation"
                    isOpen={true}
                    onCloseCallback={this.handleCancelDelete}
                    onPrimaryButtonClick={this.handleConfirmedDelete}
                    onSecondaryButtonClick={this.handleCancelDelete}
                    primaryButtonText="brokerCustomWallet-buttonConfirmDeleteWallet"
                    secondaryButtonText="brokerCustomWallet-buttonCancelDeleteWallet"
                    title="brokerCustomWallet-confirmDeleteWalletTitle"
                />
            );
        }
    }

    handleCancelDelete() {
        this.props.onCancelDelete();
    }

    handleConfirmedDelete() {
        const { wallet, idDefaultView } = this.props;
        this.props.onDelete();
        if (wallet === idDefaultView) {
            this.props.confirmedChangeDefault(BROKER_CUSTOM_WALLET_GENERAL_VIEW);
        }
    }

    render() {
        return this.buildModalDeleteConfirmation();
    }

}

BrokerCustomWalletConfirmDelete.propTypes = {
    wallet: PropTypes.number.isRequired,
    walletName: PropTypes.string.isRequired,
    onDelete: PropTypes.func.isRequired,
    onCancelDelete: PropTypes.func.isRequired,
    idDefaultView: PropTypes.object.isRequired,
    confirmedChangeDefault: PropTypes.func.isRequired
};

module.exports = BrokerCustomWalletConfirmDelete;
